<template lang='pug'>

  .pts-modal-wrapper
    .close-icon
      span.to-click(@click="closeModal") x

    h4.is-size-4.has-text-black.has-text-centered  Pontos registrados nos últimos 7 dias

    .has-text-centered
      p * ponto manual

    .columns.is-multiline.is-centered(style="flex-grow: 1; align-items: stretch;")

      template(v-if="groupedInfos.length === 0")
        br
        h1 Nenhum ponto encontrado

      .column.is-2.custom-box(v-for="dayInfo of groupedInfos")

        h3.is-size-6.has-text-black.has-text-centered.mb10  {{ dayInfo.day }} | {{dayInfo.weekDay}}

        div(style="overflow: scroll; max-height: 200px;")
          .pt-container(v-for="pt in dayInfo.pts", :class="{[pt.color]: true}")
              label.pts-box {{ pt.time }}
              label.pts-box {{ pt.kind.toLowerCase() }}



</template>

<script>
import moment from 'moment'
import { groupBy } from '../../utils'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['visual']),
    groupedInfos () {
      const { monthPts } = this.$store.state.punchTimelog

      const weekDays = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
      const classes = {'Entrada': 'success', 'Pausa': 'info', 'Retorno Pausa': 'warning', 'Saída': 'danger'}

      const daysGroup = groupBy(monthPts, 'day')
        .map((items) => {
          const milliseconds = moment(items[0], "DD/MM/YYYY");
          const newDate = new Date(milliseconds)

          return {
            day: items[0],
            weekDay: weekDays[newDate.getDay()],
            pts: items[1]
              .map(i => {

                return {
                  ...i,
                  time: `${moment(i.time).format('HH:mm')}${ i.fake ? '*' : ''} `,
                  color: this.getColor(i, classes),
                  kind: i.kind.includes('Retorno') ? 'retorno' : i.kind
                }
              })
              .reverse()
          }
        })

      return daysGroup.slice(0,7)
    }
  },
  methods: {
    closeModal () {
      this.$modal.hide('ptsModal');
    },
    getColor (point, classes) {
      if (this.visual.webRegistedByType) {
        if (point.fake){
          return this.visual.webRegistedManual
        } else {
          return this.visual.webRegistedTl
        }

      } else {
        return classes[point.kind]
      }

    }
  }
}
</script>

<style>



@media only screen and (min-width: 320px)  {

  .pts-box {
    margin-top: 2px;
    margin-left: 5%;
  }

  .close-icon {
    position: absolute;
    right: 0;
    padding-right: 7%;
    padding-top: 0.3%;
    top: 0;

  }

  .pts-modal-wrapper {
    background-color: #eee;
    width: 100%;
    max-height: 800px;
    padding: 10px;
    overflow: scroll;
  }
  .custom-box {
    margin: 1%;
    max-width: 300px;
    max-height: 100%;
  }
  .pt-container {
    display: grid;
    color: #fff;
    margin-bottom: 2%;
    grid-template-columns: 1fr 0.5fr;
  }
}


@media (min-width: 768px) {

  .pts-box {
    margin-top: 2px;
    margin-left: 5%;
  }

  .close-icon {
    position: absolute;
    right: 0;
    padding-right: 1%;
    padding-top: 0.3%

  }

  .pts-modal-wrapper {
    background-color: #eee;
    padding: 30px;
    max-height: 800px;
    overflow: scroll;
  }
  .custom-box {
    margin: 1%;
    min-width: 200px;
    max-height: 100%;
  }
  .pt-container {
    display: grid;
    color: #fff;
    margin-bottom: 2%;
    grid-template-columns: 1fr 0.5fr;
  }

}

@media (min-width: 960px) {

  .pts-box {
    margin-top: 2px;
    margin-left: 5%;
  }

  .close-icon {
    position: absolute;
    right: 0;
    padding-right: 2%;
    padding-top: 0.3%

  }

  .pts-modal-wrapper {
    background-color: #eee;
    padding: 30px;
    max-height: 800px;
    overflow: scroll;
  }
  .custom-box {
    margin: 1%;
    min-width: 200px;
    max-height: 100%;
  }
  .pt-container {
    display: grid;
    color: #fff;
    margin-bottom: 2%;
    grid-template-columns: 1fr 0.5fr;
  }

}

@media only screen and (min-width: 1024px) {
  .pts-box {
    margin-top: 2px;
    margin-left: 5%;
  }

  .close-icon {
    position: absolute;
    right: 0;
    padding-right: 1%;
    padding-top: 0.3%

  }

  .pts-modal-wrapper {
    background-color: #eee;
    padding: 30px;
    max-height: 800px;
    overflow: scroll;
  }
  .custom-box {
    margin: 1%;
    min-width: 200px;
    max-height: 100%;
  }
  .pt-container {
    display: grid;
    color: #fff;
    margin-bottom: 2%;
    grid-template-columns: 1fr 0.5fr;
  }

}

@media only screen and (min-width: 1900px) {
  .pts-box {
    margin-top: 2px;
    margin-left: 5%;
  }

  .close-icon {
    position: absolute;
    right: 0;
    padding-right: 1%;
    padding-top: 0.3%

  }

  .pts-modal-wrapper {
    background-color: #eee;
    padding: 30px;
    max-height: 800px;
    overflow: scroll;
  }
  .custom-box {
    margin: 1%;
    min-width: 200px;
    max-height: 100%;
  }
  .pt-container {
    display: grid;
    color: #fff;
    margin-bottom: 2%;
    grid-template-columns: 1fr 0.5fr;
  }

}


.pt-container.success {
  background-color: var(--color-success);
}

.pt-container.warning {
  background-color:var(--color-warning);
}

.pt-container.info {
  background-color:var(--color-info);
}

.pt-container.danger {
  background-color:var(--color-danger);
}

.pt-container.default {
  background-color:var(--color-default);
}




</style>
